import { render, staticRenderFns } from "./RedaktionBeirat.vue?vue&type=template&id=27944ac2&scoped=true&"
import script from "./RedaktionBeirat.vue?vue&type=script&lang=js&"
export * from "./RedaktionBeirat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27944ac2",
  null
  
)

export default component.exports